import { render, staticRenderFns } from "./ModalCreateOrUpdate.vue?vue&type=template&id=36272d07"
import script from "./ModalCreateOrUpdate.vue?vue&type=script&lang=js"
export * from "./ModalCreateOrUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports